import { useCallback, useSyncExternalStore } from "react";
//#region src/hooks/breakpoints.ts
const useCurrentBreakpoint = () => {
	const subscribe = useCallback((onStoreChange) => {
		window.addEventListener("resize", onStoreChange);
		return () => window.removeEventListener("resize", onStoreChange);
	}, []);
	const getSnapshot = useCallback(() => getComputedStyle(document.documentElement).getPropertyValue("--current-breakpoint").trim(), []);
	const getServerSnapshot = useCallback(() => "sm", []);
	return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
//#endregion
export { useCurrentBreakpoint };

//# sourceMappingURL=breakpoints.js.map